import { defineMessages } from 'react-intl'

const scope = 'procurify.components.BillItemPopover'

export default defineMessages({
  receivedTitle: {
    id: `${scope}.title`,
    defaultMessage: 'Received',
  },
  unitCostVarianceTitle: {
    id: `${scope}.unitCostVarianceTitle`,
    defaultMessage: 'Unit cost variance',
  },
  receivedLabel: {
    id: `${scope}.receivedLabel`,
    defaultMessage: 'Received',
  },
  previouslyBilledLabel: {
    id: `${scope}.previouslyBilledLabel`,
    defaultMessage: 'Previously billed',
  },
  billableLabel: {
    id: `${scope}.billableLabel`,
    defaultMessage: 'Billable',
  },
  billingLabel: {
    id: `${scope}.billingLabel`,
    defaultMessage: 'Billing',
  },
  poLabel: {
    id: `${scope}.poLabel`,
    defaultMessage: 'PO',
  },
  varianceLabel: {
    id: `${scope}.varianceLabel`,
    defaultMessage: 'Variance',
  },
  statusOverbilledLabel: {
    id: `${scope}.statusOverbilledLabel`,
    defaultMessage: 'Overbilled',
  },
  statusAttentionLabel: {
    id: `${scope}.statusAttentionLabel`,
    defaultMessage: 'Attention',
  },
  taxAmountEditedTitle: {
    id: `${scope}.taxAmountEditedTitle`,
    defaultMessage: 'Tax amount edited',
  },
  systemCalculatedTaxLabel: {
    id: `${scope}.systemCalculatedTaxLabel`,
    defaultMessage: 'System calculated tax',
  },
  taxExceedsSubtotalBadge: {
    id: `${scope}.taxExceedsSubtotalBadge`,
    defaultMessage: 'Tax exceeds item value',
  },
  taxExceedsSubtotalDescription: {
    id: `${scope}.taxExceedsSubtotalDescription`,
    defaultMessage: 'Total tax exceeds 100% of item value.',
  },
})
